<section *ngIf="isMobileDevice()" id="mobHeader" class="mobileSingleHeader">
	<ng-container *ngIf="isFinancialMobileSubPage(); else defaultTitle">
		<span class="pageTitle zk-text-base zk-w-full">
			{{
				financialComponent.subPageName
					? (financialComponent.getMobilePageName() | translate)
					: page.title
			}}
		</span>
		<zk-icon
			name="close"
			class="zk-cursor-pointer zk-float-right"
			(click)="financialComponent.subPageName = undefined"
		>
		</zk-icon>
	</ng-container>
	<ng-template #defaultTitle>
		<fa-icon icon="chevron-left" class="zk-mr-6" (click)="back()"></fa-icon>
		<span class="pageTitle zk-text-base">
			{{ showMenuMobile ? ('MY_ACCOUNT.TITLE' | translate) : page.title }}
		</span>
	</ng-template>
</section>

<div class="wrapper zk-flex zk-justify-center">
	<app-my-account-menu
		*ngIf="!isMobileDevice() || (isMobileDevice() && showMenuMobile)"
		[page]="page"
		[user]="user"
		(selected)="changePage($event)"
	></app-my-account-menu>

	<div
		*ngIf="!showMenuMobile"
		class="main zk-mb-12 lg:zk-mb-20 p-0 zk-bg-white zk-w-full"
	>
		<div class="header zk-hidden md:zk-flex md:zk-flex-col zk-py-6">
			<h1>{{ page.text + '.TITLE' | translate }}</h1>
			<h2>{{ page.text + '.DESCRIPTION' | translate }}</h2>
		</div>

		<div
			class="content zk-p-5 lg:zk-p-8"
			[class.full-content-height]="
				isFinancialMobileSubPage() && isMobileDevice()
			"
			[ngSwitch]="page.path"
		>
			<app-my-account-personal
				*ngSwitchDefault
				[user]="user"
				(userChanges)="updateUser($event)"
				(unsavedChanges)="haveUnsavedChanges = $event"
			></app-my-account-personal>

			<app-my-account-professional
				*ngSwitchCase="'professional'"
				(unsavedChanges)="haveUnsavedChanges = $event"
				(userUpdated)="userUpdated($event)"
			></app-my-account-professional>

			<app-my-account-plan-and-session
				*ngSwitchCase="'definitions'"
				(unsavedChanges)="haveUnsavedChanges = $event"
				(userUpdated)="userUpdated($event)"
			></app-my-account-plan-and-session>

			<online-sessions
				*ngSwitchCase="'online-sessions'"
				(unsavedChanges)="haveUnsavedChanges = $event"
				(userUpdated)="userUpdated($event)"
			></online-sessions>

			<onsite-sessions
				*ngSwitchCase="'onsite-sessions'"
				(unsavedChanges)="haveUnsavedChanges = $event"
				(userUpdated)="userUpdated($event)"
			></onsite-sessions>

			<app-my-account-financial
				#financial
				*ngSwitchCase="'payment'"
				(unsavedChanges)="haveUnsavedChanges = $event"
				(userUpdated)="userUpdated($event)"
			></app-my-account-financial>
		</div>
	</div>

	<div
		*ngIf="!showMenuMobile"
		class="onboarding zk-hidden lg:zk-flex lg:zk-flex-col"
	>
		<app-profile-completion
			[reset]="resetProfileCompletion"
			[hideDetails]="showHideDetails"
		></app-profile-completion>
	</div>
</div>

<zk-dialog *ngIf="true" [(isOpen)]="showConfirmationDialog">
	<ng-container zk-dialog-header>
		{{ 'MY_ACCOUNT.DIALOG_UNSAVED_CHANGES.TITLE' | translate }}
	</ng-container>
	<ng-container zk-dialog-body>
		<p class="zk-text-body-base zk-text-base">
			{{ 'MY_ACCOUNT.DIALOG_UNSAVED_CHANGES.CONTENT' | translate }}
		</p>
	</ng-container>
	<ng-container zk-dialog-footer>
		<div class="zk-flex zk-items-center zk-justify-center zk-w-full zk-px-4">
			<button
				zk-button
				zkButtonColor="secondary"
				type="button"
				(click)="continueNavigate()"
			>
				{{ 'MY_ACCOUNT.DIALOG_UNSAVED_CHANGES.ACCEPT' | translate }}
			</button>
			<button zk-button type="button" (click)="showConfirmationDialog = false">
				{{ 'MY_ACCOUNT.DIALOG_UNSAVED_CHANGES.DECLINE' | translate }}
			</button>
		</div>
	</ng-container>
</zk-dialog>
